<template>
  <div class="componentRoot" v-if="userData">
    <v-card>
      <v-container fluid>
        <v-row>
          <v-col :cols="appointmentCols" v-for="a in appointments" :key="a.id" class="pb-1" style="display: flex; flex-direction: column;">
            <AppointmentCardVue :appointmentData="a" :backofficeView="true"  />
          </v-col>

          <v-col v-if="!appointments || appointments.length == 0">
            <p><i>{{ $t("messages.noItems") }}</i></p>
          </v-col>
          <v-col v-else>
            <v-pagination class="mb-4 mt-2" :length="numPages" v-model="currPage"></v-pagination>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import AppointmentCardVue from '../../../../components/calendar/AppointmentCard.vue';

export default {
  props: ["userData"],
  data() {
    return {
      appointments: [],
      currPage: 1,
      numPages: 1
    };
  },

  components: {
    AppointmentCardVue
  },

  watch: {
    currPage() {
      this.fetchData()
    }
  },

  computed: {
    appointmentCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 12;
        case "sm":
          return 12;
        case "md":
          return 12;
        case "lg":
          return 6;
        case "xl":
          return 6;
        case "xxl":
          return 6;
        default:
          return 6;
      }
    },
  },

  methods: {
    fetchData() {
      this.refreshing = true;

      let query = "?id=" + this.$route.params.userID

      query += "&page=" + this.currPage

      return new Promise((resolve, reject) => {
        this.axios
          .get(
            this.axios.defaults.baseURL +
            "user/users/appointments/" + query
          )
          .then((resp) => {
            this.appointments = resp.data.results;

            if (resp.data.results.length == 0) {
              this.numPages = 0;
            } else if (this.currPage == 1) {
              this.numPages = Math.ceil(resp.data.count / resp.data.results.length);
            }

            resolve();
          })
          .catch((e) => {
            console.log(e);
            window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
            reject();
          });
      });
    },
    getReadableDate(date) {
      if (date) return this.$moment(date).format("DD.MM.YYYY");
      else return undefined;
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>
